import { useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import myImage from '../images/logo.png';  // Adjust the path to your image0

const Toolbar = ({handleChatToggle}) => {
    const [expanded, setExpanded] = useState(false);  // Track the navbar state

  return (
    <Navbar bg="primary"  expand="lg" sticky="top" className='text-light' expanded={expanded}>
      <Container>
        <LinkContainer to="/welcome">
            <Navbar.Brand className='text-light d-flex align-items-center'>
            <img
                alt="Company Logo"
                src={myImage}//"https://via.placeholder.com/30"
                width="50"
                height="50"
                className="d-inline-block"
            />{' '}
            Present-Bot 
            </Navbar.Brand>
        </LinkContainer>
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)}/>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto" onSelect={() => setExpanded(false)}>
            <LinkContainer to="/find-gift">
              <Nav.Link className='text-light'>Lass dich inspirieren</Nav.Link>
            </LinkContainer>
            <Nav.Link className='text-light' onClick={() => { handleChatToggle(); setExpanded(false); }}>Finde dein Geschenk</Nav.Link>
            <LinkContainer to="/contact">
              <Nav.Link className="text-light">Kontakt</Nav.Link>
            </LinkContainer>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Toolbar;